var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastDemandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.00073C7.58136 4.00073 4 7.58209 4 12.0007C4 16.4194 7.58136 20.0007 12 20.0007C16.4186 20.0007 20 16.4194 20 12.0007C20 7.58209 16.4186 4.00073 12 4.00073ZM1.5 12.0007C1.5 6.20138 6.20064 1.50073 12 1.50073C17.7994 1.50073 22.5 6.20138 22.5 12.0007C22.5 17.8001 17.7994 22.5007 12 22.5007C6.20064 22.5007 1.5 17.8001 1.5 12.0007Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6614 6.59692C12.3517 6.59692 12.9114 7.15657 12.9114 7.84692V11.9841L16.0718 13.8694C16.6646 14.2231 16.8586 14.9904 16.5049 15.5833C16.1512 16.1762 15.3839 16.3701 14.791 16.0164L11.021 13.7674C10.6429 13.5419 10.4114 13.1341 10.4114 12.6939V7.84692C10.4114 7.15657 10.971 6.59692 11.6614 6.59692Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2324_95130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.88574,
    y: 14.0144,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08562 20.4376C4.91229 20.4376 4.74229 20.3676 4.61562 20.241C4.59896 20.2243 4.58229 20.2043 4.56562 20.1843L3.06562 18.7076C2.82229 18.4476 2.82562 18.0343 3.07896 17.7776C3.33896 17.5176 3.76229 17.5176 4.02229 17.7776L5.08562 18.8276L8.03896 15.8776C8.29896 15.6176 8.72229 15.6176 8.98229 15.8776C9.10896 16.0043 9.17896 16.171 9.17896 16.3476C9.17896 16.5243 9.10896 16.6943 8.98229 16.8176L5.60229 20.1976C5.59896 20.2043 5.58229 20.221 5.56562 20.241C5.44896 20.3576 5.29562 20.4276 5.13229 20.4343C5.11562 20.4343 5.09896 20.4376 5.08562 20.4376Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2324_95130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.88574,
    y: 14.0144,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDemandIcon);
export default __webpack_public_path__ + "static/media/fastDemandIcon.2711cb45.svg";
export { ForwardRef as ReactComponent };